/* @jsx h */
import { defineComponent, h, type PropType } from "vue";
import type { GridColumnDef } from "../types";

export const ReadonlyViewer = defineComponent({
  name: "ReadonlyViewer",
  props: {
    column: { type: Object as PropType<GridColumnDef>, required: true },
    value: { type: null as any, default: null },
    row: { type: Object as PropType<Record<string, any>>, required: true },
  },
  setup(props) {
    return () => {
      const display = props.column.formatter
        ? props.column.formatter(props.value, props.row)
        : String(props.value ?? "");
      return <span class="lg-cell-text font-mono text-xs text-base-content/50">{display}</span>;
    };
  },
});
